/* eslint-disable angular/controller-as-route */

angular.
module("digiexam").
config(function config(
	$routeProvider,
	$httpProvider,
	$sceDelegateProvider,
	$provide,
	$animateProvider,
	$locationProvider,
	$compileProvider,
	$qProvider,

	DX_URLS,
	RoleTypeEnum,

	localStorageServiceProvider
) {
	"use strict";

	$animateProvider.classNameFilter(/dxAnimate/);

	// AngularJS 1.5.8 to 1.6.10 compatibility functions to make it work with our codebase.
	$locationProvider.hashPrefix("");					// https://code.angularjs.org/1.6.10/docs/guide/migration#-location-
	$routeProvider.eagerInstantiationEnabled(false);	// https://code.angularjs.org/1.6.10/docs/guide/migration#-route-
	$compileProvider.preAssignBindingsEnabled(true);	// https://code.angularjs.org/1.6.10/docs/guide/migration#-compile-
	$qProvider.errorOnUnhandledRejections(false);

	$sceDelegateProvider.resourceUrlWhitelist(["self", "https://www.youtube.com/embed/**"]);

	localStorageServiceProvider.prefix = "dx";
	localStorageServiceProvider.notify.setItem = false;
	localStorageServiceProvider.notify.removeItem = false;

	function defaultNoAuthRouting($window, $location, dxRegion) {
		var queryParams = $location.search();

		if ($location.path() !== DX_URLS.routes.overview) {
			queryParams.return_to = $location.url(); // eslint-disable-line camelcase
		}

		var queryString = $window.jQuery.param(queryParams);

		if (queryString) {
			queryString = "?" + queryString;
		}

		if (dxRegion.getSelected() === null) {
			$location.url(DX_URLS.routes.regions + queryString);
			return;
		} else if (dxRegion.getSelected().domain !== dxRegion.getCurrent().domain) {
			dxRegion.redirectTo(dxRegion.getSelected());
			return;
		}

		$location.url(DX_URLS.routes.login + queryString);
	}

	function requireAuth(permissions) {
		return {
			auth: function auth(
				$window,
				$q,
				$location,

				dxSession,
				dxRegion
			) {
				var deferred = $q.defer();
				var roleType = dxSession.getRole().roleType;

				var hasPermission = (permissions & roleType) > 0;
				var isPublicPermission = permissions === RoleTypeEnum.PUB;

				// Your role has permission to view this page or it is public
				if (hasPermission || isPublicPermission) {
					deferred.resolve();
					return deferred.promise;
				}

				// Your role does not have permission to view this page
				if (roleType === RoleTypeEnum.MASTER) {
					$location.url(DX_URLS.get("masterToolsSearch"));
				} else if (roleType === RoleTypeEnum.ACCOUNTMANAGER) {
					$location.url(DX_URLS.get("roles", {id: dxSession.getRole().organizationId}));
				} else if (roleType === RoleTypeEnum.ADMIN || roleType === RoleTypeEnum.TEACHER ||
					roleType === RoleTypeEnum.STUDENT || roleType === RoleTypeEnum.INVIGILATOR) {
					$location.url(DX_URLS.get("overview"));
				} else {
					defaultNoAuthRouting($window, $location, dxRegion);
				}

				return $q.reject(401);
			},
		};
	}

	$routeProvider.when(DX_URLS.routes.overview, {
		templateUrl: "partials/overview/overview.html",
		controller: "OverviewController",
		controllerAs: "vm",
		menuItem: "overview",
		resolve: requireAuth(RoleTypeEnum.STUDENT | RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN |
			RoleTypeEnum.INVIGILATOR),
	});

	$routeProvider.when(DX_URLS.routes.login, {
		templateUrl: "tmpl/login/login-route.html",
		controller: "DxLoginRouteController",
		resolve: requireAuth(RoleTypeEnum.PUB),
		hideSidebar: true,
		lobby: true,
	});

	$routeProvider.when(DX_URLS.routes.error, {
		templateUrl: "tmpl/error/error-route.html",
		controller: "DxErrorRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.PUB),
		hideSidebar: true,
		lobby: true,
	});

	$routeProvider.when(DX_URLS.routes.register, {
		templateUrl: "tmpl/register/register-route.html",
		controller: "DxRegisterRouteController",
		resolve: requireAuth(RoleTypeEnum.PUB),
	});

	$routeProvider.when(DX_URLS.routes.registerDone, {
		templateUrl: "partials/login/registerdone.html",
		controller: "DxRegisterAccountController",
		resolve: requireAuth(RoleTypeEnum.PUB),
	});

	$routeProvider.when(DX_URLS.routes.verify, {
		templateUrl: "partials/login/verify.html",
		controller: "DxVerificationController",
	});

	$routeProvider.when(DX_URLS.routes.forgotPassword, {
		templateUrl: "tmpl/forgot-password/forgot-password-route.html",
		controller: "ForgotPasswordRouteController",
		resolve: requireAuth(RoleTypeEnum.PUB),
		hideSidebar: true,
		lobby: true,
	});

	$routeProvider.when(DX_URLS.routes.forgotPasswordChange, {
		templateUrl: "tmpl/forgot-password/forgot-password-change-route.html",
		controller: "ForgotPasswordChangeRouteController",
		resolve: requireAuth(RoleTypeEnum.PUB),
		hideSidebar: true,
		lobby: true,
	});

	$routeProvider.when(DX_URLS.routes.forgotPasswordPasswordChanged, {
		templateUrl: "tmpl/forgot-password/forgot-password-password-changed-route.html",
		controller: "ForgotPasswordPasswordChangedRouteController",
		resolve: requireAuth(RoleTypeEnum.PUB),
		hideSidebar: true,
		lobby: true,
	});

	$routeProvider.when(DX_URLS.routes.setPasswordChange, {
		templateUrl: "tmpl/forgot-password/forgot-password-change-route.html",
		controller: "ForgotPasswordChangeRouteController",
		resolve: requireAuth(RoleTypeEnum.PUB),
		hideSidebar: true,
		lobby: true,
	});

	$routeProvider.when(DX_URLS.routes.setPasswordPasswordChanged, {
		templateUrl: "tmpl/forgot-password/forgot-password-password-changed-route.html",
		controller: "ForgotPasswordPasswordChangedRouteController",
		resolve: requireAuth(RoleTypeEnum.PUB),
		hideSidebar: true,
		lobby: true,
	});

	$routeProvider.when(DX_URLS.routes.regions, {
		templateUrl: "tmpl/region/region-route.html",
		controller: "DxRegionController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.PUB),
		hideSidebar: true,
		lobby: true,
	});

	$routeProvider.when(DX_URLS.routes.exams, {
		templateUrl: "tmpl/exams/exams-route.html",
		controller: "DxExamsRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
		menuItem: "exams",
		reloadOnSearch: false,
	});

	$routeProvider.when(DX_URLS.routes.rubrics, {
		templateUrl: "tmpl/rubrics/rubrics-route.html",
		controller: "DxRubricsRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
		menuItem: "rubrics",
	});

	$routeProvider.when(DX_URLS.routes.groups, {
		templateUrl: "partials/groups/groups.html",
		controller: "GroupController",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
		menuItem: "groups",
	});

	$routeProvider.when(DX_URLS.routes.classView, {
		templateUrl: "partials/class/viewclass.html",
		controller: "ViewClassController",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ACCOUNTMANAGER | RoleTypeEnum.ADMIN),
		menuItem: "groups",
	});

	$routeProvider.when(DX_URLS.routes.classAddStudents, {
		templateUrl: "tmpl/class/class-add-students-route.html",
		controller: "DxClassAddStudentsRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
		menuItem: "groups",
	});

	$routeProvider.when(DX_URLS.routes.classEdit, {
		templateUrl: "partials/class/viewclass.html",
		controller: "ViewClassController",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ACCOUNTMANAGER | RoleTypeEnum.ADMIN),
		menuItem: "groups",
	});

	$routeProvider.when(DX_URLS.routes.classInCourse, {
		templateUrl: "partials/class/viewclass.html",
		controller: "ViewClassController",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
		menuItem: "groups",
	});

	$routeProvider.when(DX_URLS.routes.examCreate, {
		templateUrl: "partials/exam/create.html",
		controller: "CreateExamController",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
		menuItem: "exams",
		hideSidebar: true,
	});

	$routeProvider.when(DX_URLS.routes.examView, {
		templateUrl: "tmpl/routes/live-view-route.html",
		controller: "DxLiveViewRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN | RoleTypeEnum.INVIGILATOR),
		menuItem: "exams",
	});

	$routeProvider.when(DX_URLS.routes.examEdit, {
		templateUrl: "partials/exam/create.html",
		controller: "CreateExamController",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
		menuItem: "exams",
		hideSidebar: true,
	});

	$routeProvider.when(DX_URLS.routes.examPrint, {
		templateUrl: "tmpl/printing/print-exam-route.html",
		controller: "DxPrintExamRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
		hideSidebar: true,
	});

	$routeProvider.when(DX_URLS.routes.examGrades, {
		templateUrl: "partials/exam/grades.html",
		controller: "ExamGradesController",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
		menuItem: "exams",
	});

	$routeProvider.when(DX_URLS.routes.examGrading, {
		templateUrl: "partials/exam/grading.html",
		controller: "ExamGradingController",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
		menuItem: "exams",
		hideSidebar: true,
	});

	$routeProvider.when(DX_URLS.routes.examGradesPrint, {
		templateUrl: "tmpl/printing/print-exam-route.html",
		controller: "DxPrintExamRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
		hideSidebar: true,
	});

	$routeProvider.when(DX_URLS.routes.results, {
		templateUrl: "partials/results/results.html",
		controller: "dxResultsController",
		resolve: requireAuth(RoleTypeEnum.STUDENT | RoleTypeEnum.TEACHER | RoleTypeEnum.ACCOUNTMANAGER |
			RoleTypeEnum.ADMIN),
	});

	$routeProvider.when(DX_URLS.routes.livePrint, {
		templateUrl: "partials/live/print.html",
		controller: "PrintLiveController",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN | RoleTypeEnum.INVIGILATOR),
		hideSidebar: true,
	});

	$routeProvider.when(DX_URLS.routes.node, {
		templateUrl: "tmpl/node/node-list-route.html",
		controller: "DxNodeListRouteController",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "organization",
	});

	$routeProvider.when(DX_URLS.routes.nodeView, {
		templateUrl: "tmpl/node/node-view-route.html",
		controller: "DxNodeViewRouteController",
		resolve: requireAuth(RoleTypeEnum.ACCOUNTMANAGER | RoleTypeEnum.MASTER),
		menuItem: "organization",
		reloadOnSearch: false,
	});

	$routeProvider.when(DX_URLS.routes.externalToolNew, {
		templateUrl: "tmpl/external-tool/external-tool-route.html",
		controller: "DxExternalToolRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.ACCOUNTMANAGER | RoleTypeEnum.MASTER),
		menuItem: "organization",
	});

	$routeProvider.when(DX_URLS.routes.externalToolEdit, {
		templateUrl: "tmpl/external-tool/external-tool-route.html",
		controller: "DxExternalToolRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.ACCOUNTMANAGER | RoleTypeEnum.MASTER),
		menuItem: "organization",
	});

	$routeProvider.when(DX_URLS.routes.roles, {
		templateUrl: "tmpl/roles/roles-view-route.html",
		controller: "DxRolesViewRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.ACCOUNTMANAGER),
		menuItem: "roles",
		reloadOnSearch: false,
	});

	$routeProvider.when(DX_URLS.routes.nodeMerge, {
		templateUrl: "tmpl/node/node-merge.html",
		controller: "NodeMergeRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "organization",
		reloadOnSearch: false,
	});

	$routeProvider.when(DX_URLS.routes.inviteAccept, {
		template: "<dx-invite-accept></dx-invite-accept>",
		hideSidebar: true,
		lobby: true,
	});

	$routeProvider.when(DX_URLS.routes.referAFriend, {
		templateUrl: "tmpl/referral/refer-a-friend-route.html",
		controller: "ReferAFriendRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ACCOUNTMANAGER | RoleTypeEnum.ADMIN),
	});

	// Should be under Admin, not master
	$routeProvider.when(DX_URLS.routes.roleCreate, {
		templateUrl: "partials/role/create.html",
		controller: "RolesController",
		resolve: requireAuth(RoleTypeEnum.ACCOUNTMANAGER | RoleTypeEnum.MASTER),
		menuItem: "rolecreate",
	});

	$routeProvider.when(DX_URLS.routes.settings, {
		templateUrl: "partials/settings.html",
		controller: "SettingsController",
		resolve: requireAuth(RoleTypeEnum.STUDENT | RoleTypeEnum.TEACHER | RoleTypeEnum.ACCOUNTMANAGER |
			RoleTypeEnum.ADMIN | RoleTypeEnum.MASTER | RoleTypeEnum.INVIGILATOR),
		menuItem: "settings",
	});

	$routeProvider.when(DX_URLS.routes.archive, {
		templateUrl: "tmpl/archive/archive-route.html",
		controller: "DxArchiveController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
	});

	$routeProvider.when(DX_URLS.routes.import, {
		templateUrl: "tmpl/import/import-route.html",
		controller: "DxImportRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
	});

	$routeProvider.when(DX_URLS.routes.rubricCreate, {
		templateUrl: "partials/grading-matrix/edit.html",
		controller: "GradingMatrixEditController",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
		menuItem: "rubrics",
		hideSidebar: true,
	});

	$routeProvider.when(DX_URLS.routes.rubricEdit, {
		templateUrl: "partials/grading-matrix/edit.html",
		controller: "GradingMatrixEditController",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
		menuItem: "rubrics",
		hideSidebar: true,
	});

	$routeProvider.when(DX_URLS.routes.rubricPrint, {
		templateUrl: "partials/grading-matrix/print.html",
		controller: "DxGradingMatrixPrintController",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
		hideSidebar: true,
	});

	$routeProvider.when(DX_URLS.routes.masterTools, {
		templateUrl: "tmpl/mastertools/mastertools-index-route.html",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "mastertools",
		reloadOnSearch: false,
	});

	$routeProvider.when(DX_URLS.routes.masterToolsRecalculateExam, {
		templateUrl: "tmpl/mastertools/recalculate-exam-route.html",
		controller: "DxRecalculateExamRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "mastertools",
	});

	$routeProvider.when(DX_URLS.routes.masterToolsBulkSetHiddenExams, {
		templateUrl: "tmpl/mastertools/bulk-set-hidden-exams-route.html",
		controller: "DxBulkSetHiddenExamsRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "mastertools",
	});

	$routeProvider.when(DX_URLS.routes.masterToolsUserDuplication, {
		templateUrl: "tmpl/mastertools/user-duplication-route.html",
		controller: "DxUserDuplicationRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "mastertools",
	});

	$routeProvider.when(DX_URLS.routes.masterToolsMoveUserData, {
		templateUrl: "partials/mastertools/moveuserdata.html",
		controller: "DxMasterToolsMoveUserDataController",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "mastertools",
	});

	$routeProvider.when(DX_URLS.routes.importStudents, {
		templateUrl: "tmpl/import-students/import-students-route.html",
		controller: "DxImportStudentsRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.MASTER | RoleTypeEnum.ACCOUNTMANAGER),
		menuItem: "mastertools",
	});

	$routeProvider.when(DX_URLS.routes.masterToolsImportTeacherData, {
		templateUrl: "tmpl/mastertools/import-teacher-data-route.html",
		controller: "DxImportTeacherDataController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "mastertools",
	});

	$routeProvider.when(DX_URLS.routes.masterToolsCleanStudents, {
		templateUrl: "tmpl/mastertools/clean-students-route.html",
		controller: "DxCleanStudentsRouteController",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "mastertools",
		reloadOnSearch: false,
	});

	$routeProvider.when(DX_URLS.routes.masterDXEToDXRConverter, {
		templateUrl: "tmpl/mastertools/dxe-to-dxr-converter-route.html",
		controller: "DxDXEToDXRConverterController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "mastertools",
		reloadOnSearch: false,
	});

	$routeProvider.when(DX_URLS.routes.masterToolsSearchIndexList, {
		templateUrl: "tmpl/mastertools/search-index-list-route.html",
		controller: "DxSearchIndexListRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "mastertools",
		reloadOnSearch: false,
	});

	$routeProvider.when(DX_URLS.routes.masterToolsSearchIndex, {
		templateUrl: "tmpl/mastertools/search-index-route.html",
		controller: "DxSearchIndexRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "mastertools",
		reloadOnSearch: false,
	});

	$routeProvider.when(DX_URLS.routes.masterToolsUserView, {
		templateUrl: "partials/mastertools/user-view.html",
		controller: "DxMasterToolsUserViewController",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "search",
	});

	$routeProvider.when(DX_URLS.routes.masterToolsStudentView, {
		templateUrl: "partials/mastertools/student-view.html",
		controller: "DxMasterToolsStudentViewController",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "search",
	});

	$routeProvider.when(DX_URLS.routes.masterToolsSearch, {
		templateUrl: "partials/mastertools/search.html",
		controller: "DxMasterToolsSearchController",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "search",
		reloadOnSearch: false,
	});

	$routeProvider.when(DX_URLS.routes.masterToolsBulkChangeEmail, {
		templateUrl: "tmpl/mastertools/bulk-change-email-route.html",
		controller: "DxBulkChangeEmailRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "mastertools",
		reloadOnSearch: false,
	});

	$routeProvider.when(DX_URLS.routes.masterToolsBulkDeleteUser, {
		templateUrl: "tmpl/mastertools/bulk-delete-user-route.html",
		controller: "DxBulkDeleteUserRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "mastertools",
		reloadOnSearch: false,
	});

	$routeProvider.when(DX_URLS.routes.masterToolsBulkDeleteStudent, {
		templateUrl: "tmpl/mastertools/studentbulkdelete/student-bulk-delete-route.html",
		controller: "DxStudentBulkDeleteRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "mastertools",
		reloadOnSearch: false,
	});

	$routeProvider.when(DX_URLS.routes.masterToolsStudentMerge, {
		templateUrl: "tmpl/mastertools/studentmerge/merge-conflicts-route.html",
		controller: "DxMergeConflictsRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "mastertools",
		reloadOnSearch: false,
	});

	$routeProvider.when(DX_URLS.routes.masterToolsUserMerge, {
		templateUrl: "tmpl/mastertools/usermerge/user-merge-route.html",
		controller: "DxUserMergeRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "mastertools",
		reloadOnSearch: false,
	});

	$routeProvider.when(DX_URLS.routes.masterToolsBulkUnifyPassword, {
		templateUrl: "tmpl/mastertools/bulk-unify-password-route.html",
		controller: "DxBulkUnifyPasswordRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.MASTER),
		menuItem: "mastertools",
	});

	$routeProvider.when(DX_URLS.routes.studentSearch, {
		templateUrl: "tmpl/student/student-search-route.html",
		controller: "DxStudentSearchRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ACCOUNTMANAGER | RoleTypeEnum.ADMIN),
		menuItem: "student",
		reloadOnSearch: false,
	});

	$routeProvider.when(DX_URLS.routes.createStudent, {
		templateUrl: "tmpl/student/create-student-route.html",
		controller: "DxCreateStudentRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.ACCOUNTMANAGER),
		menuItem: "student",
	});

	$routeProvider.when(DX_URLS.routes.student, {
		templateUrl: "tmpl/student/student-route.html",
		controller: "StudentRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ACCOUNTMANAGER | RoleTypeEnum.ADMIN),
		menuItem: "student",
	});

	$routeProvider.when(DX_URLS.routes.changeStudentCode, {
		templateUrl: "tmpl/student/change-student-code-route.html",
		controller: "DxChangeStudentCodeRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.ACCOUNTMANAGER),
		menuItem: "student",
	});

	$routeProvider.when(DX_URLS.routes.deleteStudents, {
		templateUrl: "tmpl/student/delete-students-route.html",
		controller: "DxDeleteStudentsRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.ACCOUNTMANAGER),
		menuItem: "student",
	});

	$routeProvider.when(DX_URLS.routes.support, {
		templateUrl: "tmpl/support/support-route.html",
		controller: "SupportRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.STUDENT | RoleTypeEnum.TEACHER | RoleTypeEnum.ACCOUNTMANAGER |
			RoleTypeEnum.ADMIN | RoleTypeEnum.MASTER | RoleTypeEnum.INVIGILATOR),
		menuItem: "support",
	});

	$routeProvider.when(DX_URLS.routes.ltiContentItemSelection, {
		templateUrl: "tmpl/lti/content-item-selection-route.html",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
		hideSidebar: true,
	});

	$routeProvider.when(DX_URLS.routes.ltiExamPreview, {
		templateUrl: "tmpl/lti/exam-preview-route.html",
		controller: "DxExamPreviewRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
		hideSidebar: true,
	});

	$routeProvider.when(DX_URLS.routes.ltiExamSelected, {
		templateUrl: "tmpl/lti/exam-selected-route.html",
		controller: "DxExamSelectedRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN),
		hideSidebar: true,
	});

	$routeProvider.when(DX_URLS.routes.ltiAssignment, {
		templateUrl: "tmpl/lti/assignment-route.html",
		controller: "AssignmentRouteController",
		controllerAs: "vm",
		resolve: requireAuth(RoleTypeEnum.STUDENT | RoleTypeEnum.TEACHER | RoleTypeEnum.ADMIN | RoleTypeEnum.INVIGILATOR),
		hideSidebar: true,
	});

	$routeProvider.when(DX_URLS.routes[404], {
		templateUrl: "partials/404.html",
		resolve: requireAuth(RoleTypeEnum.STUDENT | RoleTypeEnum.TEACHER | RoleTypeEnum.ACCOUNTMANAGER |
			RoleTypeEnum.ADMIN | RoleTypeEnum.MASTER | RoleTypeEnum.INVIGILATOR),
	});

	$routeProvider.when(DX_URLS.routes.jobsView, {
		templateUrl: "tmpl/jobs/jobs-view-route.html",
		controller: "DxJobsViewController",
		controllerAs: "vm",
		menuItem: "jobs",
		resolve: requireAuth(RoleTypeEnum.MASTER | RoleTypeEnum.ACCOUNTMANAGER),
	});

	$routeProvider.when(DX_URLS.routes.jobsList, {
		templateUrl: "tmpl/jobs/jobs-list-route.html",
		controller: "DxJobsListController",
		controllerAs: "vm",
		menuItem: "jobs",
		resolve: requireAuth(RoleTypeEnum.MASTER | RoleTypeEnum.ACCOUNTMANAGER),
	});

	$routeProvider.when(DX_URLS.routes.clientSettings, {
		templateUrl: "tmpl/client/client-settings-route.html",
		controller: "DxClientSettingsRouteController",
		controllerAs: "vm",
		menuItem: "client",
		resolve: requireAuth(RoleTypeEnum.MASTER),
	});

	$routeProvider.when(DX_URLS.routes.skolonAuthenticate, {
		templateUrl: "tmpl/skolon/skolon-authenticate-route.html",
		controller: "DxSkolonAuthenticateRouteController",
		resolve: requireAuth(RoleTypeEnum.PUB),
		hideSidebar: true,
		lobby: true,
	});

	// Activation was removed, but to prevent 404s, redirect them to overview if they click email link.
	$routeProvider.when(DX_URLS.routes.activateStudent, {
		redirectTo: function redirectToFn() {
			return DX_URLS.routes.overview;
		},
	});

	$routeProvider.otherwise({redirectTo: DX_URLS.routes[404]});

	$provide.factory("httpErrorInterceptor", httpErrorInterceptor);
	$httpProvider.interceptors.push("httpErrorInterceptor");

	function httpErrorInterceptor(
		$cookies,
		$rootScope,
		$q
	) {
		return {
			request: function request(reqConfig) {
				var csrfToken = $cookies.get("csrf");
				var isAssignmentApi = reqConfig.url.indexOf("assignment.api") !== -1;

				if (csrfToken && !isAssignmentApi) {
					reqConfig.headers["X-CSRF-Token"] = csrfToken;
				}

				return reqConfig;
			},

			response: function response(res) {
				return res;
			},

			responseError: function responseError(res) {
				var status = res.status;
				if (status === 401) {
					$rootScope.logout();
					return $q.reject(res);
				} else if (status >= 400 && status < 600) {
					return $q.reject(res);
				} else if (status <= 0) {
					// This is what happens during a timeout
					return $q.reject(res);
				}
				return res;
			},
		};
	}

	// Prevents GET requests from being cached by IE (WEB-867)
	// http://stackoverflow.com/questions/16098430/angular-ie-caching-issue-for-http/19771501#19771501
	var defaultHeaders = $httpProvider.defaults.headers;
	if (!defaultHeaders.get) {
		defaultHeaders.get = {};
	}
	defaultHeaders.get["Cache-Control"] = "no-cache";
});
